const SET_USER = (state, data) => {
  console.log('data', data)
  state.id = data.id
  state.email = data.email
  state.firstName = data.firstName
  state.lastName = data.lastName
  state.fullName = data.fullName
  state.initials = data.initials
  state.primaryNumber = data.primaryNumber
  state.currency = data.displayCurrency
  state.geolocation = data.countryId
  state.timezone = data.timezone
  state.profilePictureUrl = data.profilePictureUrl
  state.balance = data.account.balance.formatted
  state.balanceAmount = data.account.balance.amount
  state.bonusMinutes = data.account.bonusMinutes
  state.vatNumber = data.account.vatNumber
  state.locales = data.locales
  state.created = data.created
  state.identities = data.identities
}

const SET_PAYMENT_COUNT = (state, data) => {
  state.paymentCount = data
}

const SET_USER_SERVICES = (state, data) => {
  state.userServices = data.services.items
}
export default {
  SET_USER,
  SET_PAYMENT_COUNT,
  SET_USER_SERVICES
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js